export enum RulesEngineRuleRunTypeEnum {
    All = 0,
    TriggeredOnly = 1,
    ScheduledOnly = 2
}